import React from "react";
import "./index.sass";
import BSCIcon from "@assets/images/icons/BSC-icon.svg";
import SolanaIcon from "@assets/images/icons/Solana-icon.svg";
import BitcoinIcon from "@assets/images/icons/btc-icon.svg";
import EthereumIcon from "@assets/images/icons/ethereum-icon.svg";
import { useTranslation } from "@helpers/translate";
import useMediaQuery from "@mui/material/useMediaQuery";

const MarketsTableFilters = ({ segment, onSegmentChange }) => {
  const isMobile = useMediaQuery("(max-width: 460px)");
  const { __ } = useTranslation();

  const segments = [
    {
      id: "all",
      label: isMobile ? __("markets.tabs.all") : __("markets.segments.all"),
    },
    { id: "bsc", label: "BSC", icon: BSCIcon },
    { id: "solana", label: "Solana", icon: SolanaIcon },
    { id: "bitcoin", label: "Bitcoin", icon: BitcoinIcon },
    { id: "ethereum", label: "Ethereum", icon: EthereumIcon },
  ];

  return (
    <div className="markets-table-filters">
      <div className="markets-table-filters__pills">
        {segments.map(({ id, label, icon }) => {
          const isActive = segment === id;

          return (
            <button
              key={id}
              type="button"
              className={`markets-table-filters__pill ${
                isActive ? "markets-table-filters__pill--active" : ""
              }`}
              onClick={() => onSegmentChange(id)}
            >
              {icon && (
                <img
                  className="markets-table-filters__pill-icon"
                  src={icon}
                  alt=""
                />
              )}

              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MarketsTableFilters;
